/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from "clsx";
import { useQueryRequest } from "../../core/QueryRequestProvider";
import {
  useQueryResponse,
  useQueryResponseLoading,
} from "../../core/QueryResponseProvider";

const ListPagination = () => {
  const { response: pagination } = useQueryResponse();
  const isLoading = useQueryResponseLoading();
  const { updateState } = useQueryRequest();

  const updatePage = (page: number | null) => {
    if (!page || isLoading || pagination?.detailData.page === page) {
      return;
    }

    updateState({ page, limit: 10 });
  };

  return (
    <div className="row mt-8 mb-2">
      <div className="col-sm-12 col-md-12 d-flex align-items-center justify-content-center">
        <div id="kt_table_transaction_paginate">
          <ul className="pagination">
            <li
              className={clsx("page-item", {
                disabled: isLoading || !pagination?.detailData.hasPrevPage,
                previous: pagination?.detailData.hasPrevPage,
              })}
            >
              <a
                className={clsx("page-link page-text fs-7")}
                onClick={() =>
                  updatePage(
                    (pagination?.detailData.page
                      ? pagination?.detailData.page
                      : 1) - 1
                  )
                }
                style={{ cursor: "pointer" }}
              >
                Previous
              </a>
            </li>
            {new Array(pagination?.detailData.totalPages)
              .fill(0)
              .map((item: any, index: any) => {
                return (
                  <li
                    key={index}
                    className={clsx("page-item", {
                      active: pagination?.detailData.page === index + 1,
                      disabled: isLoading,
                    })}
                  >
                    <a
                      className={clsx("page-link")}
                      onClick={() => updatePage(index + 1)}
                      style={{ cursor: "pointer" }}
                    >
                      {index + 1}
                    </a>
                  </li>
                );
              })}
            <li
              className={clsx("page-item", {
                disabled: isLoading || !pagination?.detailData.hasNextPage,
                next: pagination?.detailData.hasNextPage,
              })}
            >
              <a
                className={clsx("page-link page-text fs-7")}
                onClick={() => {
                  updatePage(
                    (pagination?.detailData.page
                      ? pagination?.detailData.page
                      : 1) + 1
                  );
                }}
                style={{ cursor: "pointer" }}
              >
                Next
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export { ListPagination };
